import { USER_ROLES } from "../../../constants/roles";

export const canManageMedicationDefinitions = ({ currentUserId = "", child = {}, userRole = "" } = {}) => (
  Boolean(
    userRole === USER_ROLES.CARE_OWNER ||
    userRole === USER_ROLES.CARE_PARTNER ||
    (currentUserId &&
      (
      child?.users?.care_owner === currentUserId ||
      child?.users?.care_partners?.includes(currentUserId)
      ))
  )
);
